const REPORT_AUTO_RUN_QUERY_PARAM = "run";

export function buildReportRunUrl(reportUrl: string): string {
  const separator = reportUrl.includes("?") ? "&" : "?";
  return `${reportUrl}${separator}${REPORT_AUTO_RUN_QUERY_PARAM}=1`;
}

export function isReportAutoRunRequested(search: string): boolean {
  return new URLSearchParams(search).get(REPORT_AUTO_RUN_QUERY_PARAM) === "1";
}

export function clearReportAutoRunNavigation(
  pathname: string,
  search: string,
): { pathname: string; search: string; state: undefined } {
  const params = new URLSearchParams(search);
  params.delete(REPORT_AUTO_RUN_QUERY_PARAM);
  const query = params.toString();

  return {
    pathname,
    search: query ? `?${query}` : "",
    state: undefined,
  };
}
